import { defineFetch } from 'resift';

interface ArgumentTypes {
  isActive: boolean;
  sourceFileId: string;
}

const makeUpdateSourceFile = defineFetch({
  displayName: 'Update Source File',
  make: (sourceId: string) => ({
    key: [],
    request: ({ isActive, sourceFileId }: ArgumentTypes) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/source-files/${sourceFileId}`,
        data: {
          isActive,
        },
      }),
  }),
});

export default makeUpdateSourceFile;
